import { StyleSheet } from 'react-native';
import { dimensions, colors } from '../../../../styles';

export default StyleSheet.create({
  mainContainer: {
    paddingHorizontal: dimensions.medium,
    paddingTop: dimensions.doubleMedium,
  },
});
